// Eager: Vite 8 drops an unused lazy glob before emitting the files, so Vite::asset() could not find them in the manifest.
import.meta.glob(['../images/**'], { eager: true });

import navbar from './components/navbar.js';
import phone from './components/phone.js';
import reveal from './components/reveal.js';
import aboutMarquee from './components/sections/about-marquee.js';
import cases from './components/sections/cases.js';
import hero from './components/sections/hero.js';
import intro from './components/sections/intro.js';
import joinUs from './components/sections/join-us.js';
import methodology from './components/sections/methodology.js';
import servicesList from './components/sections/services-list.js';
import testimonials from './components/sections/testimonials.js';

const modules = [
	['header', navbar],
	['.services', hero],
	['.text-marquee', aboutMarquee],
	['.venn', reveal],
	['.intro', intro],
	['.challenges ul', reveal],
	['#methodology', methodology],
	['#services', servicesList],
	['.cases', cases],
	['.testimonials ul', reveal],
	['.testimonials', testimonials],
	['#application-cv', joinUs],
	['#contact-phone', phone],
	['#application-phone', phone],
];

for (const [selector, init] of modules) {
	const element = document.querySelector(selector);

	if (element) {
		init(element);
	}
}
